import * as actions from '../services'
import * as types from './mutations-types'
import { addFlash } from 'src/app/components/shareds/flash/vuex/mutations-types'
import { t } from 'src/utils/form'

export const loadPlansByUsername = (context, username) => {
  return actions.getPlansByUsername(username)
  .then(function (response) {
    if (response && response.status === 200) {
      context.commit(types.setSubscribePlans, response.data.plans)
    } else if (response && response.status === 422) {
      context.commit(addFlash, { message: t(context, 'message'), type: 'ls-alert-success' })
    }
    return response
  })
}

export const loadSellerData = (context, username) => {
  return actions.getSellerByUsername(username)
  .then(function (response) {
    if (response && response.status === 200) {
      context.commit(types.setBasicSeller, response.data.seller)
    }
    return response
  })
}

export const verifyEmail = (context, email) => {
  return actions.validateEmail(email)
  .then(function (response) {
    return response
  })
}

export const checkCpf = (context, cpf) => {
  return actions.validateCpf(cpf)
    .then(function (response) {
      return response
    })
}

export const loadCust = (context, payload) => {
  return actions.getAddress(payload)
  .then(function (response) {
    if (response && response.status === 200) {
      context.commit(types.setAddress, response.data.address)
    }
    return response
  })
}



// WEBPACK FOOTER //
// ./src/app/pages/subscribe/vuex/actions.js